<template>
  <v-card outlined class="student-list-card">
    <v-card-title class="headline">Danh sách học sinh</v-card-title>
    <v-divider></v-divider>
    <v-list>
      <v-list-item-group v-model="selectedStudentIndex" color="primary">
        <template v-if="loading">
          <v-list-item>
            <v-list-item-content>
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item v-for="(student, index) in students" :key="student.id" @click="selectStudent(student, index)">
            <v-list-item-avatar>
              <v-img :src="student.avatar || 'path/to/default/avatar.png'"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ student.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ student.studentCode }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon v-if="student.evaluated" color="green">mdi-check-circle</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    evaluationId: {
      type: String,
      required: true
    },
    classId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      students: [],
      selectedStudentIndex: null,
      loading: false
    }
  },
  methods: {
    ...mapActions('student', ['fetchStudents']),
    ...mapActions('evaluateStudent', ['fetchEvaluateStudents']),
    async fetchData() {
      if(!this.classId) return
      this.loading = true
      try {
        const [studentsResponse, evaluationResponse] = await Promise.all([
          this.fetchStudents({
            classes: this.classId,
            status: 'active',
            _sort: 'nameToNumber:ASC,index:ASC',
          }),
          this.fetchEvaluateStudents({
            evaluate: this.evaluationId
          })
        ])

        if (studentsResponse && typeof studentsResponse === 'object') {
          const evaluatedStudentIds = evaluationResponse && Array.isArray(evaluationResponse)
            ? evaluationResponse.map(item => item.student.id)
            : []

          this.students = Object.values(studentsResponse).map((student) => ({
            ...student,
            evaluated: evaluatedStudentIds.includes(student.id),
          }))
        } else {
          console.error('Invalid response format for students')
        }
      } catch (error) {
        console.error('Error fetching data:', error.message || 'Unknown error')
      } finally {
        this.loading = false
      }
    },
    selectStudent(student, index) {
      this.selectedStudentIndex = index
      this.$emit('student-selected', student, index)
    },
    updateStudentEvaluationStatus(index, status) {
      if (index >= 0 && index < this.students.length) {
        this.students[index].evaluated = status
      }
    }
  },
  watch: {
    classId: 'fetchData',
    evaluationId: 'fetchData'
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
.student-list-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.student-list-card .v-list {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
